<template>
  <a-drawer
    :open="open"
    :width="480"
    class="custom-class"
    root-class-name="root-class-name"
    placement="right"
    @close="closeDrawer('price')"
  >
    <Text :type="'subHeader'" :text="'Change price'" />
    <Text :type="'textFadedMedium'" :text="'Edit Product and volume'" />

    <div v-if="activeProducts.length" class="mt-2">
      <div v-bind:key="index" v-for="(product, index) in activeProducts">
        <div
          class="flex items-center justify-between px-3 py-2 mb-3 border rounded-lg border-grey300"
        >
          <div>
            <div class="flex items-center">
              <span>
                <img src="@/assets/svg/productPms.svg" />
              </span>
              <span class="text-sm text-grey500">
                {{ product.productName }}
              </span>
            </div>
            <div>
              <p class="mt-2 text-base text-grey500">
                Product Volume: {{ product.productVolume }}
              </p>
            </div>
          </div>
          <div @click="editProduct(product)" class="cursor-pointer">
            <img src="@/assets/svg/edit.svg" />
          </div>
        </div>
      </div>
    </div>
    <form @submit.prevent="handleSubmit" action="" class="mt-4">
      <div class="mt-3">
        <LabelText :forVal="'productSelect'" :labelText="'Select product'" />
        <select
          class="w-full px-4 py-2 border-[1px] text-base bg-transparent rounded-lg border-grey300 font-quietSans placeholder-grey500 outline-foundationGrey500 focus:border-foundationGrey500"
          name="name"
          v-model="productName"
          :value="productName"
        >
          <option value="" selected disabled>Select a product</option>
          <option
            :value="product.depotProductName"
            v-bind:key="product.depotProductId"
            v-for="product in products"
          >
            {{ product.depotProductName }}
          </option>
        </select>
      </div>

      <div class="mt-3">
        <LabelText :forVal="'product_volume'" :labelText="'Product Price'" />

        <!-- <div class="w-full">
          <a-input-number
            class="w-full px-2 py-1 text-sm rounded-md border-[1px] border-foundationGrey500 font-quietSans placeholder-foundationGrey500 outline-foundationGrey500 focus:border-foundationGrey500"
            v-model="productPrice"
            :formatter="
              (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
          />
        </div> -->

        <input
          class="w-full px-4 py-2 text-sm rounded-md border-[1px] border-foundationGrey500 font-quietSans placeholder-foundationGrey500 outline-foundationGrey500 focus:border-foundationGrey500"
          v-model="productPrice"
          :placeholder="'Set product price'"
          :name="'productPrice'"
          :type="'text'"
          :value="productPrice"
        />
      </div>

      <div class="mt-3">
        <LabelText :forVal="'startDate'" :labelText="'Select Start Date'" />
        <VueDatePicker
          color="#00903a"
          input-size="sm"
          v-model="startDate"
          :min-date="todayDate"
          no-label
          format="YYYY-MM-DDTHH:mm:ss"
        />
      </div>

      <div class="mt-3">
        <LabelText :forVal="'date'" :labelText="'Select End Date'" />
        <VueDatePicker
          color="#00903a"
          input-size="sm"
          v-model="endDate"
          :min-date="todayDate"
          no-label
          format="YYYY-MM-DDTHH:mm:ss"
        />
      </div>

      <!-- <div class="mt-3">
        <LabelText :forVal="'product_volume'" :labelText="'Maximum Volume'" />

        <input
          class="w-full px-4 py-2 text-sm border rounded-md border-foundationGrey500 font-quietSans placeholder-foundationGrey500 outline-foundationGrey500 focus:border-foundationGrey500"
          v-model="productVolume"
          :placeholder="'50,000l'"
          :name="'productVolume'"
          :type="'text'"
          :value="productVolume"
        />
      </div> -->

      <!-- <div class="mt-3">
        <LabelText :forVal="'current_volume'" :labelText="'Current Volume'" />

        <input
          class="w-full px-4 py-2 text-sm border rounded-md border-foundationGrey500 font-quietSans placeholder-foundationGrey500 outline-foundationGrey500 focus:border-foundationGrey500"
          v-model="newVolume"
          :placeholder="'Enter new volume'"
          :name="'newPrice'"
          :type="'text'"
          :value="newVolume"
        />
      </div> -->

      <div
        v-if="activeProducts.length > 1"
        class="flex items-center my-2 cursor-pointer"
        @click="addProduct"
      >
        <span><img src="@/assets/svg/addGreen.svg" /></span>
        <p class="ml-2 text-sm text-primaryGreen">Add more product</p>
      </div>
      <div class="mt-8">
        <FormSubmitInput :val="'Update price'" :loading="loading" />
      </div>
    </form>
  </a-drawer>
</template>

<script>
//Library
import moment from "moment";
import { useToast } from "vue-toastification";

//services
import depotService from "@/services/depot-service";

//component
import FormSubmitInput from "../../../UI/Inputs/FormSubmitInput.vue";
import Text from "../../../UI/Text/Text.vue";
import FadedBorderWrapper from "../../../UI/Wrappers/FadedBorderWrapper.vue";
import LabelText from "../../../UI/Text/LabelText.vue";

export default {
  components: { Text, FadedBorderWrapper, FormSubmitInput, LabelText },
  props: ["open", "closeDrawer", "products", "getDepotDetails"],
  data() {
    return {
      productVolume: "",
      productName: "",
      newPrice: "",
      startDate: "",
      endDate: "",
      toast: useToast(),
      activeProducts: [],
      loading: false,
      productPrice: "",
      newVolume: "",
      todayDate: moment().format("YYYY-MM-DD"),
    };
  },

  methods: {
    editProduct(product) {
      this.productName = product.productName;
      this.newPrice = product.newPrice;
      // this.productVolume = product.productVolume;
      this.startDate = product.startDate;
      this.endDate = product.endDate;
      this.productPrice = product.productPrice;
      // this.newVolume = product.newVolume;
    },
    async handleSubmit() {
      this.loading = true;
      if (!this.validateData()) {
        this.toast.error(
          "All fields for the current product should be filled",
          { timeout: 5000 }
        );
        this.loading = false;
        return;
      }
      this.addProduct();
      let urlVal = new URLSearchParams(window.location.search);
      urlVal = urlVal.get("id");
      // convert the data gotten to the correct form
      const payload = this.activeProducts.map((item) => {
        return {
          productId: item.productId,
          price: +this.stripNonNumber(item.productPrice),
          // maxCapacity: +this.stripNonNumber(item.productVolume),
          // currentQuantity: +this.stripNonNumber(item.newVolume),
          startDate: item.startDate,
          endDate: item.endDate,
        };
      });

      // Make api call
      try {
        const mapSales = await depotService.changeDepotPrice(
          `Depot/AddProductSale?depotId=${urlVal}`,
          payload
        );

        this.toast.success("Depot Product Price changed successfully", {
          timeout: 2000,
        });
        this.getDepotDetails();
        this.closeDrawer();
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },

    stripNonNumber(val) {
      return val
        .split("")
        .map((item) => {
          return !isNaN(item) || item === "." ? item : "";
        })
        .join("")
        .replaceAll(" ", "");
    },

    validateData() {
      if (
        !this.productName ||
        !this.startDate ||
        !this.endDate ||
        // !this.productVolume ||
        !this.productPrice
        // || !this.newVolume
      ) {
        return false;
      }
      return true;
    },
    resetFields() {
      (this.productName = ""),
        (this.newPrice = ""),
        (this.startDate = ""),
        (this.endDate = ""),
        // (this.productVolume = "");
        (this.productPrice = "");
      // this.newVolume = "";
    },
    resolveId(productName) {
      return this.products.find((item) => item.depotProductName == productName)
        .depotProductId;
    },
    addProduct() {
      // Validate before pushing
      if (!this.validateData()) {
        this.toast.error(
          "All fields for the current product should be filled",
          { timeout: 5000 }
        );
        return;
      }

      const findVal = this.activeProducts.findIndex(
        (item) => item.productName == this.productName
      );
      // Update if you find a new one
      if (findVal !== -1) {
        this.activeProducts[findVal] = {
          productName: this.productName,
          newPrice: this.newPrice,
          // productVolume: this.productVolume,
          startDate: this.startDate,
          endDate: this.endDate,
          productPrice: this.productPrice,
          productId: this.resolveId(this.productName),
          // newVolume: this.newVolume,
        };
      } else {
        // create a new one
        this.activeProducts.push({
          productName: this.productName,
          newPrice: this.newPrice,
          // productVolume: this.productVolume,
          startDate: this.startDate,
          endDate: this.endDate,
          productId: this.resolveId(this.productName),
          productPrice: this.productPrice,
          // newVolume: this.newVolume,
        });
      }

      this.resetFields();
    },
  },
};
</script>

<style>
.ant-drawer-content-wrapper {
  /* drawer size */
  /* width: 460px !important; */
  background: red;
}

@media (max-width: 768px) {
  .ant-drawer-content-wrapper {
    width: 100% !important;
  }
}
</style>
